<div class="wide">
  <p-table
    #table
    (onPage)="onPrimePageChange($event)"
    (onSort)="onPrimeSortChange($event)"
    [customSort]="true"
    [lazyLoadOnInit]="false"
    [lazy]="true"
    [loading]="isDataLoading()"
    [paginatorStyleClass]="'customPrimePaginator'"
    [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [rows]="tablePage()?.size || 10"
    [tableStyle]="{ 'min-width': '50rem' }"
    [totalRecords]="tablePage()?.totalElements || 0"
    [value]="rows()"
  >
    <ng-template #header>
      <tr>
        <th pSortableColumn="imie">
          <div class="flex items-center gap-2">
            Imię
            <p-sortIcon field="imie" />
          </div>
        </th>
        <th pSortableColumn="nazwisko">
          <div class="flex items-center gap-2">
            Nazwisko
            <p-sortIcon field="nazwisko" />
          </div>
        </th>
        <th pSortableColumn="pesel">
          <div class="flex items-center gap-2">
            PESEL
            <p-sortIcon field="pesel" />
          </div>
        </th>
        <th pSortableColumn="rola">
          <div class="flex items-center gap-2">
            Rola
            <p-sortIcon field="rola" />
          </div>
        </th>
        <th>Akcje</th>
      </tr>
    </ng-template>
    <ng-template #body let-representative>
      <tr>
        <td>{{ representative.imie }}</td>
        <td>{{ representative.nazwisko }}</td>
        <td>{{ representative.pesel }}</td>
        <td>
          {{
            representative.rola
              | constLabelReader: ROLA_REPREZNTANTA_ORGANIZACJI_LABELS
          }}
        </td>
        <td>
          <div class="flex gap-4">
            @if (
              representative.rola !== RolaReprezentantaOrganizacji.WLA &&
              !userHasPlenipotentiaryRole()
            ) {
              <p-button
                type="button"
                (click)="openDeleteRepresentativeDialog(representative)"
                ariaLabel="Usuń"
                pTooltip="Usuń"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
                <i class="pi pi-trash icon" aria-hidden="true"></i>
              </p-button>
              @if ((representative.zalaczniki?.length ?? 0) > 0) {
                <p-button
                  type="button"
                  (click)="downloadAllAttachments(representative)"
                  ariaLabel="Pobierz załączniki"
                  pTooltip="Pobierz załączniki"
                  tooltipPosition="top"
                  [rounded]="true"
                  [text]="true"
                >
                  <i class="pi pi-download icon" aria-hidden="true"></i>
                </p-button>
              }
              <p-button
                type="button"
                (click)="openEditMemberModal(representative)"
                ariaLabel="Edytuj"
                pTooltip="Edytuj"
                tooltipPosition="top"
                [rounded]="true"
                [text]="true"
              >
                <i class="pi pi-pen-to-square icon" aria-hidden="true"></i>
              </p-button>
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="flex justify-between mt-5">
    <div>
      @if (!userHasPlenipotentiaryRole()) {
        <p-button
          type="button"
          aria-label="Dodaj użytkownika"
          label="Dodaj użytkownika"
          styleClass="customInfoButton"
          [text]="true"
          (click)="openAddMemberModal()"
        />
      }
    </div>
  </div>
</div>
<div class="narrow">
  <div class="flex flex-col gap-10">
    @for (row of rows(); track row.idBeneficjenta) {
      <p-card>
        <div class="flex flex-col">
          <app-preview-data-wrapper
            label="Imię"
            [data]="row.imie"
          ></app-preview-data-wrapper>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="Nazwisko"
            [data]="row.nazwisko"
          ></app-preview-data-wrapper>
          <hr class="limiter" />
          <app-preview-data-wrapper
            label="PESEL"
            [data]="row.pesel"
          ></app-preview-data-wrapper>
          <app-preview-data-wrapper
            label="Rola"
            [data]="row.rola"
          ></app-preview-data-wrapper>

          @if (row.rola !== RolaReprezentantaOrganizacji.WLA) {
            <div class="flex justify-end gap-5 mt-5">
              <p-button
                label="Usuń"
                styleClass="customInfoButton outlined"
                (click)="openDeleteRepresentativeDialog(row)"
              />
              <p-button
                label="Edytuj"
                styleClass="customInfoButton outlined"
                (click)="openEditMemberModal(row)"
              />
            </div>
          }
        </div>
      </p-card>
    }
  </div>
  <p-paginator
    (onPageChange)="onPrimePageChange($event)"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="tablePage()?.size"
    [totalRecords]="tablePage()?.totalElements"
    pageLinkSize="3"
  />
  <div class="flex justify-between mt-5">
    <p-button
      type="button"
      aria-label="Dodaj użytkownika"
      [text]="true"
      label="Dodaj użytkownika"
      styleClass="customInfoButton"
      (click)="openAddMemberModal()"
    />
  </div>
</div>
